import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import { prepareFilters } from '../../../../components/Filters/request';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item.user,
      key: item.user.uuid,
      creator: item.user,
      progress: item.progress,
      links: item.links,
      clicks: item.clicks,
      sales: item.gmv,
      cost: item.cost,
      roas: item.roas,
      select: { id: item.user.uuid, value: false },
      operations: item.user
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getAssignmentCreatorsPerformance({ payload: { id, signal, filters, searchQ, curr_page } }) {
  try {

    const { data } = yield call(fetch, {
      api: api.modifiers.assignments.participants,
      id,
      // params: { page: curr_page, ...(searchQ && { q: searchQ }) },
      data: {
        ...prepareFilters(filters),
        ...(searchQ && { q: searchQ }),
        page: curr_page
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getAssignmentCreatorsPerformanceDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getAssignmentCreatorsPerformanceFailed,
      endpoint: api.modifiers.assignments.participants.url
    });
  }
}

export const getAssignmentCreatorsPerformanceSaga = takeEvery(types.GET_ASSIGNMENT_CREATORS_PERFORMANCE_REQUEST, getAssignmentCreatorsPerformance);